import SelectComponent from '@componentes/select/select.component';
import Switch from 'react-switch';
import React from 'react';
import { Label, Row, Col, FormGroup, Button, Input } from 'reactstrap';
import '../../configuracao.style.css';
import IntlMessage from '../../../../../src/helpers/intlMessage';

const ConfiguracoesCertificadoPage = (props) => (
  <div
    style={{
      height: `${props.altura}px`,
      width: '100%',
      overflowY: 'scroll',
      overflowX: 'hidden',
    }}
  >
    <form onSubmit={(e) => props.salvar(e)}>
      <div className="config-item">
        <Row>
          <Col sm="auto">
            <Label><IntlMessage id = "dashboards.general.enabledigitalCertification"/></Label>
          </Col>
          <Col>
            <Switch
              onChange={props.changeHabilitar}
              checked={props.habilitar}
            />
          </Col>
        </Row>
      </div>
      <div className="config-item">
        <Row>
          <Col sm="auto">
            <Label><IntlMessage id = "dashboards.general.HSM"/></Label>
          </Col>
          <Col>
            <Switch onChange={props.changeHSM} checked={props.hsm} />
          </Col>
        </Row>
      </div>
      <div className="config-item">
      <Row>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.urldigitalRegistry"/></Label>
            <Input
              required
              type="url"
              className="borda-arredondada"
              value={props.urlCartorio}
              onChange={(e) => props.changeUrl(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.shippingType"/></Label>
            <SelectComponent
              options={props.tiposEnvios}
              value={props.modoEnvio}
              placeholder="Selecione um tipo de Envio"
              onChange={(event) => props.changeTipoEnvio(event)}
            />
          </FormGroup>
        </Col>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.digitalNotaryVersion"/></Label>
            <Input
              required
              type="text"
              minLength="5"
              className="borda-arredondada"
              value={props.versaoCartorio}
              onChange={(e) => props.changeVersaoCartorio(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      </div>
      
      <Button
        className="exame-personalidado-button"
        color="primary"
        type="submit"
      >
        <IntlMessage id = "dashboards.examDetail.save"/>
      </Button>
  
    </form>
  </div>
);

export default ConfiguracoesCertificadoPage;



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/certificado/certificado.page.js